/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Max_Characters_Per_LineInputs */

const en_max_characters_per_line = /** @type {(inputs: Max_Characters_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Characters Per Line`)
};

const fr_max_characters_per_line = /** @type {(inputs: Max_Characters_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max caractères par ligne`)
};

const de_max_characters_per_line = /** @type {(inputs: Max_Characters_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Zeichen pro Zeile`)
};

const it_max_characters_per_line = /** @type {(inputs: Max_Characters_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di caratteri per riga`)
};

const ru_max_characters_per_line = /** @type {(inputs: Max_Characters_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальное количество символов в строке`)
};

const es_max_characters_per_line = /** @type {(inputs: Max_Characters_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de caracteres por línea`)
};

const zh_cn2_max_characters_per_line = /** @type {(inputs: Max_Characters_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每行最大字符数`)
};

const ja_max_characters_per_line = /** @type {(inputs: Max_Characters_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行あたりの最大文字数`)
};

const hi_max_characters_per_line = /** @type {(inputs: Max_Characters_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति पंक्ति अधिकतम अक्षर`)
};

const pt_pt2_max_characters_per_line = /** @type {(inputs: Max_Characters_Per_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de caracteres por linha`)
};

/**
* | output |
* | --- |
* | "Max Characters Per Line" |
*
* @param {Max_Characters_Per_LineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const max_characters_per_line = /** @type {((inputs?: Max_Characters_Per_LineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Max_Characters_Per_LineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_max_characters_per_line(inputs)
	if (locale === "de") return de_max_characters_per_line(inputs)
	if (locale === "it") return it_max_characters_per_line(inputs)
	if (locale === "ru") return ru_max_characters_per_line(inputs)
	if (locale === "es") return es_max_characters_per_line(inputs)
	if (locale === "zh-CN") return zh_cn2_max_characters_per_line(inputs)
	if (locale === "ja") return ja_max_characters_per_line(inputs)
	if (locale === "hi") return hi_max_characters_per_line(inputs)
	if (locale === "pt-PT") return pt_pt2_max_characters_per_line(inputs)
	return en_max_characters_per_line(inputs)
});